export const isFalsy = (value: any, checkZeroValue = false) => {
  if (checkZeroValue) {
    return (
      value === false ||
      value === 0 ||
      value === -0 ||
      value === '0' ||
      value === '' ||
      value === null ||
      value === undefined ||
      value === Number.NaN
    );
  }

  return (
    value === false || value === '' || value === null || value === undefined || value === Number.NaN
  );
};
